import { requestCommon } from 'live/lib/utils'

import { CHANNELS_BASE_URL, CHANNELS_REST_ENDPOINTS } from 'plugin-channelmanager/utils/constants'

export interface IChannelTypesListFilters {
    /** number of itens per page */
    perPage?: number
    /** page to request page start in 0 */
    page?: number
    /** field to orderBy */
    orderBy?: string
    /** orderBy Direction */
    direction?: 'ASC' | 'DESC'
    /** This will filter by operation id */
    filterBy?: number
    /** string to search */
    keyword?: string
}

export const listChannelTypes = async (params?: IChannelTypesListFilters): Promise<IChannelType[]> => {
    const qs = new URLSearchParams({
        limit: params?.perPage?.toString() ?? '',
        offset: (Math.max(1, params?.page ?? 1) - 1)?.toString() ?? '0',
        keyword: params?.keyword?.toString() ?? '',
        orderBy: params?.orderBy?.toString()?.toUpperCase() ?? 'ID',
        direction: params?.direction?.toString() ?? 'ASC'
    }).toString()

    return fetch(`${CHANNELS_BASE_URL}/${CHANNELS_REST_ENDPOINTS.CHANNEL_TYPES}/?${qs}`, {
        ...requestCommon,
        method: 'GET'
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

// export const createChannelType = async (body: IChannelType): Promise<IChannelType> => {
//     return fetch(`${CHANNELS_BASE_URL}/${CHANNELS_REST_ENDPOINTS.CHANNEL_TYPES}/`, {
//         ...requestCommon,
//         method: 'POST',
//         body: JSON.stringify(body)
//     }).then(async data => {
//         let jsonData

//         try {
//             jsonData = await data.json()
//         } catch (err) {
//             jsonData = undefined
//         }

//         if (data.ok) {
//             return jsonData
//         } else {
//             throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
//         }
//     })
// }

// export const updateChannelType = async (body: IChannelType): Promise<IChannelType> => {
//     return fetch(`${CHANNELS_BASE_URL}/${CHANNELS_REST_ENDPOINTS.CHANNEL_TYPES}/${body.id}`, {
//         ...requestCommon,
//         method: 'PATCH',
//         body: JSON.stringify(body)
//     }).then(async data => {
//         let jsonData

//         try {
//             jsonData = await data.json()
//         } catch (err) {
//             jsonData = undefined
//         }

//         if (data.ok) {
//             return jsonData
//         } else {
//             throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
//         }
//     })
// }

// export const deleteChannelType = async (id: string): Promise<void> => {
//     if (!id) {
//         throw new Error('Missing id')
//     }

//     return fetch(`${CHANNELS_BASE_URL}/${CHANNELS_REST_ENDPOINTS.CHANNEL_TYPES}/${id}`, {
//         ...requestCommon,
//         method: 'DELETE'
//     }).then(async data => {
//         let jsonData

//         try {
//             jsonData = await data.json()
//         } catch (err) {
//             jsonData = undefined
//         }

//         if (data.ok) {
//             return jsonData
//         } else {
//             throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
//         }
//     })
// }
